import Vue from 'vue'
import Vuex from 'vuex'
import 'babel-polyfill';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: '',//登錄憑證
    userInfo: {},//用戶信息
    admin_name: '',//管理員名稱
    username: '',//管理員ID，後臺憑證
    chargeRecord: '',//保存充值信息，退回修改免去獲取充值詳情
    refundRecord: '',//保存退款信息，退回修改免去獲取退款詳情
    isRefCharge: '',//審核充值後，根據審核狀態刷新充值管理列表
    isRefCheck: false,//是否刷新旅行社審核列表
    isRefrRefund: false,//審核退款後，根據審核狀態刷新退款管理列表
    groupType: '',//記錄選中的群組狀態
    areaArr: [],//記錄選中地區的數據
    subject: '', content: ''
  },
  mutations: {
    token(state, token)
    {//保存token憑證
      state.token = token;
    }, saveAdmin_name(state, admin_name)
    { //保存管理員名稱
      state.admin_name = admin_name;
    }, saveUsername(state, username)
    { //保存管理員ID
      state.username = username;
    }, saveChargeRecord(state, chargeRecord)
    { //保存充值信息，退回修改免去獲取充值詳情
      state.chargeRecord = chargeRecord;
    }, saveRefundRecord(state, refundRecord)
    { //保存退款信息，退回修改免去獲取退款詳情
      state.refundRecord = refundRecord;
    }, isRefCharge(state, isRefCharge)
    {
      state.isRefCharge = isRefCharge;
    }, isRefCheck(state, isRefCheck)
    {
      state.isRefCheck = isRefCheck;
    }, isRefRefund(state, isRefRefund)
    {
      state.isRefRefund = isRefRefund;
    }, // 存儲轉發郵件的內容
    saveEmailMess(state, params)
    {
      state.groupType = params.groupType;
      state.areaArr = params.areaArr;
      state.subject = params.subject;
      state.content = params.content;
    },
    setUserInfo(state, value)
    {
      state.userInfo = value
    },
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/commonality/vuex.js